import { usePage } from '@inertiajs/vue3'

export default (role, user = null) => {
  const roles = (user ? user.roles : usePage().props.auth.roles).map((r) =>
    typeof r === 'string' ? r : r.name
  )
  const requiredRoles = Array.isArray(role) ? role : [role]

  return roles.some((role) => requiredRoles.includes(role))
}
